import * as React from "react"
import type { HeadFC } from "gatsby"

interface TitleProps {
  title: string | React.ReactElement;
  classes: string;
}

const Title = (props:TitleProps) => {

  return (
    <div className={props.classes} style={{fontFamily:`'Nunito Sans', sans-serif`}}>
      {props.title}
    </div>
  )
}

export default Title
